import Quill from 'quill';

const BlockEmbed = Quill.import('blots/block/embed') as any;

export class CustomImageBlot extends BlockEmbed {
    static blotName = 'image';
    static tagName = 'img';

    static create(value: any) {
        const src = typeof value === 'string' ? value : value.src;
        const node = super.create(src);
        node.setAttribute('src', src);

        if (typeof value === 'object') {
            if (value.style) node.setAttribute('style', value.style);
            if (value.alt) node.setAttribute('alt', value.alt);
        }

        return node;
    }

    static value(node: HTMLElement) {
        return {
            src: node.getAttribute('src') || '',
            style: node.getAttribute('style') || '',
            alt: node.getAttribute('alt') || ''
        };
    }
}
